import React from 'react';
import { Box } from 'native-base';
import { ActionButton } from '../ActionButton';
import { GIFTCARD_FLOWS, i18nFn, observer, useSpringBigStore } from '@springbig/shared';
import { Caption } from '~/shared/Typography';

const AddGiftCard = ({ t }: { t: i18nFn }) => {

    const { merchant } = useSpringBigStore();

    return (
        <Box>
            <Caption textAlign={'center'} fontSize={24}>
                { t('giftCard.add.title', [merchant?.gift_card_alias]) }
            </Caption>
            <ActionButton
                title={t('giftCard.add.uploadButton', [merchant?.gift_card_alias])}
                onPress={() => observer.emit('change-screen', GIFTCARD_FLOWS.existingGiftCard)}
            />
            {/* remove ability to purchase GC altogether */}
            {/*<ActionButton*/}
            {/*    title={t('giftCard.add.fundButton', [merchant?.gift_card_alias])}*/}
            {/*    onPress={() => observer.emit('change-screen', GIFTCARD_FLOWS.addFunds)}*/}
            {/*/>*/}
        </Box>
    );
};

export default AddGiftCard;
